module.exports = __webpack_public_path__ + "img/errorimage.33697e7f.png";